<template>
  <Transition name="slide-down">
    <div v-if="visible" class="fixed top-0 left-1/2 -translate-x-1/2 w-full max-w-[430px] z-[100] px-4" style="padding-top: calc(12px + var(--safe-top));">
      <div class="rounded-xl px-4 py-3 flex items-start gap-3 shadow-lg cursor-pointer"
           style="background: #CC4444"
           @click="register">
        <div class="flex-1 min-w-0">
          <p class="text-13 font-semibold text-white leading-snug">Гостевой период заканчивается</p>
          <p class="text-12 text-white/80 leading-snug mt-0.5">Зарегистрируйтесь, чтобы сохранить данные дневника</p>
        </div>
        <button @click.stop="dismiss" class="shrink-0 mt-0.5">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useAuthStore } from '../store/auth.js'
import { track } from '../analytics.js'

const authStore = useAuthStore()
const visible = ref(false)

watch(() => authStore.showGuestExpiryWarning, (val) => {
  if (val) {
    visible.value = true
    track('guest_expiry_warning_shown')
  }
})

function dismiss() {
  visible.value = false
  authStore.showGuestExpiryWarning = false
  sessionStorage.setItem('guest-expiry-dismissed', '1')
}

function register() {
  visible.value = false
  authStore.showGuestExpiryWarning = false
  authStore.openAuthPopup()
}
</script>

<style scoped>
.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateX(-50%) translateY(-100%);
  opacity: 0;
}
.slide-down-enter-to,
.slide-down-leave-from {
  transform: translateX(-50%) translateY(0);
  opacity: 1;
}
</style>
